(function () {
    'use strict';
    angular.module('Directives').directive('bbaAccountingCustomerDetails', bbaAccountingCustomerDetails);
    bbaAccountingCustomerDetails.$inject = [
        'AccountingCarrierSurchargesTable',
        'AccountingAffiliateTable',
        'AccountingOtherChargesTable',
        'AdminPermissionService',
        'PermissionHelpers',
        '$rootScope'
    ];

    function bbaAccountingCustomerDetails(
        AccountingCarrierSurchargesTable,
        AccountingAffiliateTable,
        AccountingOtherChargesTable,
        AdminPermissionService,
        PermissionHelpers,
        $rootScope
    ) {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/components/accounting/bbaAccountingCustomerDetails.html',
            require: '^form',
            scope: {
                ngModel: '=',
                currency: '=',
                officeLocation: '=',
                manifestedDate: '=',
                bookingDate: '=',
                importedInvoicedDate: '=',
                isViewMode: '=',
                isDomestic: '=',
                affiliateCommission: '=',
                promoCode: '=',
            },
            link: bbaAccountingCustomerDetailsLink
        }

        function bbaAccountingCustomerDetailsLink($scope) {
            const decimalPlaces = 2;
            $scope.recalculate = recalculate;
            $scope.addSurchargeCallback = addSurchargeCallback;
            init();

            function init() {
                initializeTables();
                setIsHideRatesEngine();
            }

            function initializeTables() {
                $scope.affiliateTable = new AccountingAffiliateTable($scope.affiliateCommission, $scope.isViewMode, $scope.currency, $scope.addSurchargeCallback);
                $scope.carrierSuchargeTable = new AccountingCarrierSurchargesTable($scope.ngModel.surchargeDetails, $scope.isViewMode, $scope.currency, $scope.addSurchargeCallback);
                $scope.carrierSurchargeTableData = $scope.carrierSuchargeTable.tableData;
                $scope.affiliateTableData = $scope.affiliateTable.tableData;

                $scope.otherChargesTable = new AccountingOtherChargesTable(
                    $scope.ngModel.additionalCharges,
                    $scope.currency,
                    $scope.isViewMode
                );
                $scope.otherChargesTableData = $scope.otherChargesTable.tableData;
                // Total Escluding Tax 
            }

            function addSurchargeCallback() {
                $scope.ngModel.surchargeDetails = $scope.carrierSuchargeTable.getSurchargesDetails();
            }

            function calculateFuelLevy() {
                const sellPrice = Number($scope.ngModel.sellPrice);
                const valueFuel = Number($scope.ngModel.valueFuel);
                const percentFuel = Number($scope.ngModel.percentFuel);
                const fuelPercentageValue = ((sellPrice + valueFuel) * percentFuel) / 100;
                const fuelLevy = valueFuel + fuelPercentageValue;

                $scope.ngModel.percentValueMargin = fuelPercentageValue.toFixed(2);
                $scope.ngModel.fuelLevyTotal = fuelLevy;
            }

            function calculateMargin() {
                const sellPrice = Number($scope.ngModel.sellPrice);
                const valueMargin = Number($scope.ngModel.valueMargin);
                const percentMargin = Number($scope.ngModel.percentMargin);

                const fuelLevy = Number($scope.ngModel.fuelLevyTotal);
                const surchargesTotal = Number($scope.ngModel.carrierSurchargesTotal);
                const marginPercentValue = (((sellPrice + Number($scope.ngModel.valueFuel)) + Number($scope.ngModel.percentFuel) + valueMargin) * percentMargin) / 100;

                $scope.ngModel.percentValueMargin = marginPercentValue.toFixed(2);
                $scope.ngModel.marginTotal = Number(marginPercentValue + valueMargin).toFixed(2);

                return Number((((sellPrice + fuelLevy + surchargesTotal + valueMargin) * percentMargin) / 100)) + Number(valueMargin.toFixed(2));
            }

            function calculateBaseRateFuelLevySubTotal() {
                const sellPrice = Number($scope.ngModel.sellPrice);
                const fuelLevy = Number($scope.ngModel.fuelLevyTotal);
                const subTotal = sellPrice + fuelLevy;
                return subTotal;
            }

            function populateDriversCommissionFormValues(baseFuelMarginCarrierOthersSubTotal) {
                const commissionPercentageValue = angular.calculateCommissionPercentageValue(baseFuelMarginCarrierOthersSubTotal, $scope.ngModel.driverCommissionPercentage);
                const commission = Number(commissionPercentageValue) > Number($scope.ngModel.driverCommissionFixed) ? commissionPercentageValue : $scope.ngModel.driverCommissionFixed;
                $scope.ngModel.driverCommissionPercentageValue = commissionPercentageValue;
                $scope.ngModel.driverFee = commission;
                return commission;
            }

            function calculateCommissionAffiliate() {

            }

            function recalculate() {
                // calculate fuel
                calculateFuelLevy();
                const baseRateFuelLevyTotal = calculateBaseRateFuelLevySubTotal();
                const discount = angular.getObjVal($scope.promoCode, 'totalDiscount') ? Number($scope.promoCode.totalDiscount) : 0;

                // commsion
                // if($scope.affiliateCommission){
                //     const totalPercentageValue = $scope.affiliateCommission.commissionPercent ? $scope.affiliateCommission.totalCommission : 0;
                //     const commissionPercent = $scope.affiliateCommission.commissionPercent ? $scope.affiliateCommission.commissionPercent : 0;
                //     $scope.affiliateCommission.totalPercentageValue = totalPercentageValue.toFixed(2);
                //     $scope.affiliateCommission.commissionPercent = commissionPercent;
                // }
                if ($scope.promoCode) {
                    const totalDiscountPercentageValue = $scope.promoCode.discountPercent ? $scope.promoCode.totalDiscount : 0;
                    const discountPercent = $scope.promoCode.discountPercent ? $scope.promoCode.discountPercent : 0;
                    console.log(totalDiscountPercentageValue)
                    $scope.promoCode.totalDiscountPercentageValue = totalDiscountPercentageValue;
                    $scope.promoCode.discountPercent = discountPercent;
                }

                const totalCarrierSurcharges = $scope.carrierSuchargeTable.getTotalSurcharges(Number($scope.ngModel.sellPrice));
                $scope.ngModel.carrierSurchargesTotal = totalCarrierSurcharges.surchargeTotal.toFixed(2);
                const FuelLevyMarginSubTotal = Number(baseRateFuelLevyTotal + Number(totalCarrierSurcharges.surchargeTotal)).toFixed(2)
                $scope.ngModel.baseRateFuelLevyMarginSubTotal = FuelLevyMarginSubTotal;

                // calculate margin
                const marginTotal = calculateMargin();
                const baseRateFuelLevyMarginSubTotal = Number(baseRateFuelLevyTotal) + Number(totalCarrierSurcharges.surchargeTotal.toFixed(2)) + Number(marginTotal);
                const totalOtherCharges = $scope.otherChargesTable.getOtherChargesTotal();

                $scope.ngModel.otherSurchargeTotal = totalOtherCharges.toFixed(2);

                const baseRateFuelSurcharseOthersSubTotal = angular.getObjVal($scope.promoCode, 'totalDiscount') ? Number(baseRateFuelLevyMarginSubTotal) + Number(totalOtherCharges) - discount : Number(baseRateFuelLevyMarginSubTotal) + Number(totalOtherCharges);
                $scope.ngModel.baseFuelMarginCarrierOthersSubTotal = baseRateFuelSurcharseOthersSubTotal.toFixed(2) < 0 ? 0 : baseRateFuelSurcharseOthersSubTotal.toFixed(2);

                // driver commision
                const commission = populateDriversCommissionFormValues(baseRateFuelSurcharseOthersSubTotal);

                let totalAmount = 0;
                if ($scope.isDomestic) {
                    const tax = ((baseRateFuelSurcharseOthersSubTotal + Number(commission)) * Number($scope.ngModel.taxPercent)) / 100;
                    totalAmount = Number(baseRateFuelSurcharseOthersSubTotal) + Number(commission) + Number(tax);
                    $scope.ngModel.tax = tax.toFixed(2) < 0 ? 0 : tax.toFixed(2);
                } else {
                    totalAmount = Number(baseRateFuelSurcharseOthersSubTotal) + Number(commission);
                }

                $scope.ngModel.totalExcludingTax = (Number(baseRateFuelSurcharseOthersSubTotal.toFixed(2)) + Number(commission)).toFixed(2) < 0 ? 0 : (Number(baseRateFuelSurcharseOthersSubTotal.toFixed(2)) + Number(commission)).toFixed(2);
                $scope.ngModel.cost = totalAmount.toFixed(2) < 0 ? 0 : totalAmount.toFixed(2);

            }

            function setIsHideRatesEngine() {
                AdminPermissionService.AdminCurrentUser.getAdminUserDetails(success => {
                    const moduleAccess = [];
                    success.content.forEach(user => {
                        user.modules.forEach(module => {
                            moduleAccess.push(module.name);
                        });
                    });
                    $scope.isHideRatesEngine = PermissionHelpers.isHideRatesEngine(moduleAccess);
                }, error => { }, $rootScope.GlobalProfile.id);
            }
        }
    }
})();



// WEBPACK FOOTER //
// ./js/directives/component/accounting/bbaAccountingCustomerDetails.js